import { useQuery } from "@tanstack/react-query";
import { getNewsletterSubscribers } from "@/api/newsletter";

export const useNewsletterSubscribers = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ["newsletter", "subscribers", params],
    queryFn: () => getNewsletterSubscribers(params),
    keepPreviousData: true,
    ...options,
  });
};
